<template>
    <ul class="tab-menu">
        <li class="tab-menu__item">
            <router-link to="/kr/mypage/babyNote/babyDiary">산모일기</router-link>
        </li>
        <li class="tab-menu__item active">
            <router-link to="/kr/mypage/babyNote/checkupRecord">검진기록</router-link>
        </li>
        <li class="tab-menu__item">
            <router-link to="/kr/mypage/babyNote/birthRecord">출산기록</router-link>
        </li>
    </ul>
    <div class="info">
        <div class="my__blood-top">
            <div class="blood-calendar">
                <div class="blood-calendar__top">
                    <a href="javascript:;" class="blood-calendar--today" @click="todayCalendar">오늘</a>
                    <a href="javascript:;" class="blood-calendar--button prev" @click="prevCalendar"></a>
                    <h4 class="title02">{{ calYear }}-{{ calMonth }}</h4>
                    <a href="javascript:;" class="blood-calendar--button next" @click="nextCalendar"></a>
                </div>
                <table class="blood-calendar__body hover-none">
                    <caption> 예약일 선택 테이블 </caption>
                    <colgroup>
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>일</th>
                            <th>월</th>
                            <th>화</th>
                            <th>수</th>
                            <th>목</th>
                            <th>금</th>
                            <th>토</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- td classList - none: 지난달, 다음달 / on:  측정기록이 있는날 / active -->
                        <tr v-for="item in arrChunk(calendarList)" :key="item">
                            <td v-for="i in item" :key="i" :class="[i.dayType, { 'active': i.text == activeIndex }]">
                                <a href="javascript:;" @click="[selectDate(i), activeIndex = i.text]">
                                    {{ i.day }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="blood-calendar__bottom">
                    <p>
                        <span class="c-red">*</span> 조회 및 등록을 원하시는 날짜를 선택해주세요.
                    </p>
                    <div class="blood-calendar__state">
                        <div class="blood-calendar__state__item">
                            <span></span>
                            기록
                        </div>
                        <div class="blood-calendar__state__item">
                            <span></span>
                            오늘
                        </div>
                    </div>
                </div>
            </div>
            <div class="headbook">
                <div class="headbook__top">
                    <h4 class="title02">{{ rsvCount }} 개의 기록</h4>
                </div>
                <div class="mother-diary-wrap">
                    <ul class="mother-diary">
                        <li class="mother-diary__item" v-for="item in sliceList(rsvList)" :key="item">
                            <a href="javascript:;" :class="{'active': rsvDetail['PACT_ID'] == item['PACT_ID']}" @click="selectDate(item)">
                                <p class="mother-diary--title">{{ this.transTimestamp(item.MED_DT).dot }}</p>
                                <span class="mother-diary--arrow">
                                    <img src="/resource/icon/mother-diary--arrow-mom.svg" alt="">
                                </span>
                            </a>
                        </li>
                    </ul>
                    <kr_Pagination :totCnt="rsvCount" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount"
                        @setNum="setNum" />
                </div>
            </div>
        </div>
    </div>
    <div class="info" v-if="mode == 'show'">
        <div class="table-wrap">
            <div class="table headtable">
                <table>
                    <colgroup>
                        <col style="width:25%;">
                        <col style="width:75%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="" colspan="2">
                                <div class="headtable__header">
                                    <h4 class="title02">{{this.transTimestamp(rsvDetail.MED_DT).dot}}</h4>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="2" class="left">
                                <div class="baby-records">
                                    <h4 class="title01 baby-records--title">{{rsvDetail.PRG_WEEK}}주</h4>
                                    <div class="baby-records__info">
                                        <h5 class="title02">엄마</h5>
                                        <div class="table column type03">
                                            <table>
                                                <colgroup>
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                </colgroup>
                                                <tbody>
                                                    <tr>
                                                        <th>신장</th>
                                                        <td class="left">{{rsvDetail.HEIGHT ? rsvDetail.HEIGHT + ' cm' : ''}}</td>
                                                        <th>체중</th>
                                                        <td class="left">{{rsvDetail.WEIGHT ? rsvDetail.WEIGHT + ' kg' : ''}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>BMI</th>
                                                        <td class="left">{{calcBMI(rsvDetail) ? calcBMI(rsvDetail) + ' kg/m²' : ''}}</td>
                                                        <th>혈압</th>
                                                        <td class="left">{{rsvDetail.SBP}} / {{ rsvDetail.DBP }} mmHg</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="baby-records__info" v-if="rsvDetail.AC_1 || rsvDetail.BPD_1 || rsvDetail.EFW_1 || rsvDetail.FL_1">
                                        <h5 class="title02">첫째 아기</h5>
                                        <div class="table column type03">
                                            <table>
                                                <colgroup>
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                </colgroup>
                                                <tbody>
                                                    <tr>
                                                        <th>신장</th>
                                                        <td class="left"></td>
                                                        <th>체중</th>
                                                        <td class="left">{{rsvDetail.EFW_1 ? rsvDetail.EFW_1 + ' g' : ''}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>머리둘레</th>
                                                        <td class="left">{{rsvDetail.BPD_1 ? rsvDetail.BPD_1 + ' cm' : ''}}</td>
                                                        <th>허벅지길이</th>
                                                        <td class="left">{{ rsvDetail.FL_1 ? rsvDetail.FL_1 + ' cm' : '' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="baby-records__info" v-if="rsvDetail.AC_2 || rsvDetail.BPD_2 || rsvDetail.EFW_2 || rsvDetail.FL_2">
                                        <h5 class="title02">둘째 아기</h5>
                                        <div class="table column type03">
                                            <table>
                                                <colgroup>
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                </colgroup>
                                                <tbody>
                                                    <tr>
                                                        <th>신장</th>
                                                        <td class="left"></td>
                                                        <th>체중</th>
                                                        <td class="left">{{rsvDetail.EFW_2 ? rsvDetail.EFW_2 + ' g' : ''}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>머리둘레</th>
                                                        <td class="left">{{rsvDetail.BPD_2 ? rsvDetail.BPD_2 + ' cm' : ''}}</td>
                                                        <th>허벅지길이</th>
                                                        <td class="left">{{ rsvDetail.FL_2 ? rsvDetail.FL_2 + ' cm' : '' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="baby-records__info" v-if="rsvDetail.AC_3 || rsvDetail.BPD_3 || rsvDetail.EFW_3 || rsvDetail.FL_3">
                                        <h5 class="title02">셋째 아기</h5>
                                        <div class="table column type03">
                                            <table>
                                                <colgroup>
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                    <col style="width:25%;">
                                                </colgroup>
                                                <tbody>
                                                    <tr>
                                                        <th>신장</th>
                                                        <td class="left"></td>
                                                        <th>체중</th>
                                                        <td class="left">{{rsvDetail.EFW_3 ? rsvDetail.EFW_3 + ' g' : ''}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>머리둘레</th>
                                                        <td class="left">{{rsvDetail.BPD_3 ? rsvDetail.BPD_3 + ' cm' : ''}}</td>
                                                        <th>허벅지길이</th>
                                                        <td class="left">{{ rsvDetail.FL_3 ? rsvDetail.FL_3 + ' cm' : '' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="info">
        <h3 class="bullet01">체중 그래프</h3>
        <div class="table-search">
            <VueDatePicker v-model="selectedDateRange" locale="ko" :enable-time-picker="false" :format="customFormat"
                :week-start="0" :day-class="getDayClass" :select-text="'선택'" :cancel-text="'취소'" :range="true"
                :multi-calendars="true" placeholder="날짜를 선택하세요." />
            <ul class="table-select__button-wrap">
                <ul class="table-select__button-wrap">
                <li><a href="javascript:;" :class="{ 'table-select--sub-btn': true, 'active': period == 7 }"
                        @click="changePeriod(7)">1주일</a></li>
                <li><a href="javascript:;" :class="{ 'table-select--sub-btn': true, 'active': period == 1 }"
                        @click="changePeriod(1)">1개월</a></li>
                <li><a href="javascript:;" :class="{ 'table-select--sub-btn': true, 'active': period == 3 }"
                        @click="changePeriod(3)">3개월</a></li>
                <li><a href="javascript:;" :class="{ 'table-select--sub-btn': true, 'active': period == 6 }"
                        @click="changePeriod(6)">6개월</a></li>
            </ul>
            </ul>
        </div>
        <div class="blood-chart-wrap">
            <div class="blood-chart">
                <div>
                    <Line class="blood-chart-inner" :data="filteredChartData" :options="chartOptions" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale, ChartDataLabels);

export default {

    components: {
        VueDatePicker,
        Line,
    },
    data() {
        return {
            isMobile: false, // 모바일 여부를 체크할 변수
            selectedDateRange: [new Date(), new Date()], // 날짜 선택값
            customFormat: 'yyyy-MM-dd',  // 날짜 포맷
            chartData: {
                labels: ['2024-02-04', '2024-06-20', '2024-07-29'],
                datasets: [
                    {
                        label: 'HealthInfo 1',
                        backgroundColor: 'transparent',
                        borderColor: '#09847d',
                        pointBackgroundColor: '#fff',
                        data: [55.4, 59.5, 63.1,],
                        fill: false,
                        tension: 0.4,
                        borderWidth: 1,  // 선의 두께
                        pointRadius: 7,  // 포인트 크기
                        pointBorderWidth: 3,  // 포인트의 테두리 두께
                        datalabels: {
                            anchor: 'end',
                            align: (context) => {
                                return 'end';
                            },
                            formatter: (value) => value,
                            color: 'white',
                            backgroundColor: '#09847d',
                            borderRadius: 3,
                            padding: {
                                top: 4,
                                bottom: 2,
                                left: 8,
                                right: 8,
                            },
                            width: 200,
                            font: {
                                size: 16,
                                weight: '700',
                            },
                        },
                    },
                ],
            },
            chartOptions: this.getChartOptions(), // 초기 차트 옵션

            // 캘린더
            classList: '',
            startDate: '',
            endDate: '',
            today: new Date(),
            calendarList: '',
            calYear: '',
            calMonth: '',
            activeIndex: '',
            toDay: this.$commonUtils.getToday(),
            selectDay: '',

            mode: 'list',

            rsvList: [],
            rsvDetail: '',
            rsvCount: 0,

            pageRow: 6,
            currentNum: this.$route.query.currentNum || 1,
            pageCount: 5,

            period: 7,
            subDataList: [],
        };
    },
    created() {
        this.init()
        this.getRsvList()
        this.changePeriod(7)
    },
    mounted() {
        this.updateMobileStatus(); // 초기 모바일 상태 확인
        window.addEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 등록
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 제거
    },
    watch: {
        selectedDateRange: {
            handler(newData) {                
                this.getChartList()
            }
        }
    },
    methods: {
        getRsvListForGraph(start, end){
            this.axios.get(this.api.babyNote.graph, {
                params: {
                    'startDt': start,
                    'endDt': end
                }
            }).then(res => {
                const data = res.data.filter(i => i.result).filter(i => i.DBP)

                this.subDataList = []
                data.forEach(item => {
                    item.logDay = this.transTimestamp(item.MED_DT).string
                    if (start <= item.logDay && end >= item.logDay) {
                        this.subDataList.push(item);
                    }
                });

                this.chartData.labels = []
                this.chartData.datasets[0].data = []
                for (let i of this.subDataList.sort((a, b) => a.logDay - b.logDay)) {
                    this.chartData.labels.push(this.$commonUtils.makeDateFormat(i.logDay, '-'))
                    this.chartData.datasets[0].data.push(Number(i.WEIGHT).toFixed(1))
                }
            })
        },
        getChartList() {
            if(!this.selectedDateRange[0] || !this.selectedDateRange[1]){
                return
            }
            const startDt = this.$commonUtils.dateToStr(this.selectedDateRange[0], '')
            const endDt = this.$commonUtils.dateToStr(this.selectedDateRange[1], '')

            this.getRsvListForGraph(startDt, endDt)
        },
        changePeriod(_period) {
            this.period = _period;
            var startDate = new Date();
            var endDate = new Date();

            if (this.period == 7) {
                startDate.setDate(startDate.getDate() - this.period);
            } else {
                startDate.setMonth(startDate.getMonth() - this.period);
            }

            this.selectedDateRange = [startDate, endDate];
            // this.getChartList();
        },
        calcBMI(item){
            const h = item.HEIGHT
            const w = item.WEIGHT
            if(!h || !w) return ''
            const bmi = (w / ((h / 100) * (h / 100))).toFixed(2);
            return bmi
        },
        selectDate(item) {
            const pactId = item.pactId ? item.pactId : item.PACT_ID
            if (pactId) {
                this.mode = 'show'
                for (let i of this.rsvList) {
                    if (i.PACT_ID == pactId) {
                        this.rsvDetail = i
                    }
                }
            }
        },
        // pagination emit
        setNum(n) {
            this.currentNum = n
        },
        sliceList(list){
            if(list.length == 0){
                return []
            }
            const endNum = this.currentNum * this.pageRow
            return list.slice(this.currentNum - 1, Math.min(endNum, this.rsvCount))
        },
        getRsvList(){
            this.axios.get(this.api.babyNote.list2, {
                params: {
                    'IN_SEL_MONTH': this.calYear+''+this.calMonth
                }
            }).then(res => {
                this.rsvList = res.data
                if(this.rsvList.length > 0){
                    this.rsvList = this.rsvList.filter(item => item.DBP)
                }
                this.rsvCount = this.rsvList.length

                this.classList = []
                this.rsvList.forEach(item => {
                    const obj = {}
                    obj.text = this.transTimestamp(item.MED_DT).string
                    obj.date = this.transTimestamp(item.MED_DT).date
                    obj.dayType = 'on'
                    obj.pactId = item.PACT_ID
                    this.classList.push(obj)
                });

                if (this.classList) {
                    for (let i of this.calendarList) {
                        for (let j of this.classList) {
                            if (i.text == j.text) {
                                i.dayType += ` ${j.dayType}`
                                i.pactId = j.pactId
                            }
                        }
                    }
                }
            })
        },
        getRsvDetail(id){
            this.axios.get(this.api.babyNote.detail, {
                params: {
                    'IN_PACT_ID': id
                }
            }).then(res => {
                return res.data.WEIGHT
            })
        },
        updateMobileStatus() {
            this.isMobile = window.innerWidth < 768; // 모바일 기준: 768px 이하
            this.chartOptions = this.getChartOptions(); // 차트 옵션 업데이트
        },
        getChartOptions() {
            if (this.isMobile) {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 40,
                            right: 30, // 모바일에서의 오른쪽 패딩
                            bottom: 0,
                            left: 0,
                        },
                    },
                    scales: {
                        y: {
                            title: {
                                display: true,
                                text: 'none',
                                padding: {
                                    top: -0,
                                    right: -40,
                                    left: 10,
                                },
                                font: {
                                    size: 0,
                                    weight: '400',
                                },
                            },
                            ticks: {
                                padding: 18, // 모바일에서의 ticks 패딩
                                font: {
                                    size: 14,
                                    weight: '400',
                                },
                            },
                            grid: {
                                display: true,
                                drawBorder: false,
                            },
                        },
                        x: {
                            ticks: {
                                padding: 10, // 모바일에서의 x축 ticks 패딩
                                font: {
                                    size: 16,
                                    weight: '500',
                                },
                            },
                            grid: {
                                display: false,
                                drawBorder: false,
                            },
                        },
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            enabled: false,
                        },
                        datalabels: {
                            display: true,
                        },
                    },
                    elements: {
                        point: {
                            radius: 5, // 포인트 크기
                            hoverRadius: 5,
                            pointStyle: 'rectRot', // 마름모 형태
                            borderColor: 'red',    // 테두리 색상 (빨간색)
                            backgroundColor: 'white', // 배경 색상 (흰색)
                            borderWidth: 2,        // 테두리 두께
                        },
                    },
                };
            } else {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 0,
                            right: 115, // PC에서의 오른쪽 패딩
                            bottom: 0,
                            left: 0,
                        },
                    },
                    scales: {
                        y: {
                            title: {
                                display: true,
                                text: 'none',
                                padding: {
                                    top: -10,
                                    right: -100,
                                },
                                font: {
                                    size: 0,
                                    weight: '400',
                                },
                            },
                            ticks: {
                                padding: 50, // PC에서의 ticks 패딩
                                font: {
                                    size: 16,
                                    weight: '400',
                                },
                                maxTicksLimit: 6
                            },
                            grid: {
                                display: true,
                                drawBorder: false,
                            },
                        },
                        x: {
                            ticks: {
                                padding: 20, // PC에서의 x축 ticks 패딩
                                font: {
                                    size: 18,
                                    weight: 'bold',
                                },
                            },
                            grid: {
                                display: false,
                                drawBorder: false,
                            },
                        },
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            enabled: false,
                        },
                        datalabels: {
                            display: true,
                        },
                    },
                    elements: {
                        point: {
                            radius: 10, // 포인트 크기
                            hoverRadius: 5,
                            pointStyle: 'rectRot', // 마름모 형태
                            borderColor: 'red',    // 테두리 색상 (빨간색)
                            backgroundColor: 'white', // 배경 색상 (흰색)
                            borderWidth: 1,        // 테두리 두께
                        },
                    },
                };
            }
        },
        /**
         * 이번 달의 첫 날, 마지막 날 구하기
         */
         init() {
            this.startDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
            this.endDate = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0);
            this.createCalendar();
        },
        /**
         * 달력 생성
         */
        createCalendar() {
            this.activeIndex = ''
            this.calendarList = [];
            this.calYear = this.today.getFullYear();
            this.calMonth = this.$commonUtils.leftPad(this.today.getMonth() + 1);

            if (this.startDate.getDay() > 0) {
                let preLastSunDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), ((this.startDate.getDay() - 1) * -1));
                let preLastDate = new Date(preLastSunDate.getFullYear(), preLastSunDate.getMonth() + 1, 0);

                // 지난달 구하기
                for (let preDay = preLastSunDate; preDay <= preLastDate; preDay.setDate(preDay.getDate() + 1)) {
                    let date = {
                        year: preDay.getFullYear(),
                        month: this.$commonUtils.leftPad(preDay.getMonth() + 1),
                        day: this.$commonUtils.leftPad(preDay.getDate()),
                        week: preDay.getDay(), // 0~6
                        text: this.$commonUtils.dateToStr(preDay, ''),
                        dayType: 'none'
                    }

                    this.calendarList.push(date);
                }
            }

            let today = new Date();
            today.setHours(0, 0, 0, 0); // 시간 초기화

            // 이번달 구하기
            for (let nowDay = this.startDate; nowDay <= this.endDate; nowDay.setDate(nowDay.getDate() + 1)) {
                let date = {
                    year: nowDay.getFullYear(),
                    month: this.$commonUtils.leftPad(nowDay.getMonth() + 1),
                    day: this.$commonUtils.leftPad(nowDay.getDate()),
                    week: nowDay.getDay(),
                    text: this.$commonUtils.dateToStr(nowDay, ''),
                    dayType: ''
                }

                if (nowDay < today) {
                    // date.dayType = "pastDay";
                } else if (nowDay.getFullYear() == today.getFullYear()
                    && nowDay.getMonth() == today.getMonth() && nowDay.getDate() == today.getDate()) {
                    date.dayType = "today";
                } else {
                    // date.dayType = "futureDay";
                }

                this.calendarList.push(date);
            }

            // 다음달 구하기
            if (this.endDate.getDay() < 6) {
                let nextFirstDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth() + 1, 1);
                let nextFirstSunDate = new Date(nextFirstDate.getFullYear(), nextFirstDate.getMonth(), ((this.endDate.getDay() - 7) * -1) - 1);

                for (let nextDay = nextFirstDate; nextDay <= nextFirstSunDate; nextDay.setDate(nextDay.getDate() + 1)) {
                    let date = {
                        year: nextDay.getFullYear(),
                        month: this.$commonUtils.leftPad(nextDay.getMonth() + 1),
                        day: this.$commonUtils.leftPad(nextDay.getDate()),
                        week: nextDay.getDay(),
                        text: this.$commonUtils.dateToStr(nextDay, ''),
                        dayType: 'none'
                    }

                    this.calendarList.push(date);
                }
            }

            // dayType에 class 부여
            const stringYear = this.calYear.toString()
            const stringMonth = this.calMonth.toString()
            if (this.classList) {
                for (let i of this.calendarList) {
                    for (let j of this.classList) {
                        if (i.text == j.text && i.year == stringYear && i.month == stringMonth) {
                            i.dayType += ` ${j.dayType}`
                        }
                    }
                }
            }
        },
        todayCalendar() {
            this.today = new Date();
            this.init();
            this.getRsvList()
            this.selectDay = this.toDay
        },
        prevCalendar() {
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() - 1, 1);
            this.init();
            this.getRsvList()
        },
        nextCalendar() {
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1);
            this.init();
            this.getRsvList()
        },
        arrChunk(arr) {
            return arr.reduce(function (acc, val, index) {
                const chunkIndex = Math.floor(index / 7);
                if (!acc[chunkIndex]) {
                    acc[chunkIndex] = [];
                }
                acc[chunkIndex].push(val);
                return acc;
            }, []);
        },
        transTimestamp(input){
            let result = {dot: '', string: '',date: ''}
            if(!input){
                return result
            }

            const regex = /\/Date\((\d+)([+-]\d{4})\)\//;
            const matches = input.match(regex);

            if (matches) {
                const timestamp = parseInt(matches[1], 10);
                const timezoneOffset = matches[2];
                
                const offsetHours = parseInt(timezoneOffset.substring(1, 3), 10);
                const offsetMinutes = parseInt(timezoneOffset.substring(3, 5), 10);
                
                const date = new Date(timestamp);
                
                date.setHours(date.getHours() + offsetHours);
                date.setMinutes(date.getMinutes() + offsetMinutes);
                
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const hours = date.getHours();
                const minutes = date.getMinutes();
                const seconds = date.getSeconds();

                result.dot = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
                result.string = `${year}${month.toString().padStart(2, '0')}${day.toString().padStart(2, '0')}`;
                result.date =  `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            }
            return result
        }
    },
    computed: {
        filteredChartData() {
            return {
                ...this.chartData,
                datasets: [this.chartData.datasets[0]]
            }
        },
    },
};
</script>



<style scoped></style>